import apiClient from './client'

export interface LikertQuestion {
  id: string
  text: string
}

export interface Survey {
  survey_id: string
  title: string
  description: string | null
  likert_questions: LikertQuestion[]
  free_text_question: string
  status: 'draft' | 'published'
  opens_at: string | null
  closes_at: string | null
  created_by: string
  created_at: string
  updated_at: string
}

export interface LikertQuestionResult {
  question_id: string
  question_text: string
  distribution: Record<number, number>
  average: number
}

export interface IndividualResponse {
  user_id: string
  user_email: string
  user_name: string
  likert_answers: Record<string, number>
  free_text_answer: string
  created_at: string
  updated_at: string
}

export interface SurveyResults {
  survey_id: string
  total_responses: number
  likert_results: LikertQuestionResult[]
  individual_responses: IndividualResponse[]
}

export interface CreateSurveyInput {
  title: string
  description?: string
  likertQuestions: LikertQuestion[]
  freeTextQuestion: string
}

export interface UpdateSurveyInput {
  title?: string
  description?: string
  likertQuestions?: LikertQuestion[]
  freeTextQuestion?: string
}

export interface PublishSurveyInput {
  opensAt: string
  closesAt: string
}

export const surveysApi = {
  list: async (): Promise<Survey[]> => {
    const response = await apiClient.get<{ surveys: Survey[] }>('/admin/surveys')
    return response.surveys
  },

  get: async (id: string): Promise<Survey> => {
    return apiClient.get<Survey>(`/admin/surveys/${id}`)
  },

  create: async (input: CreateSurveyInput): Promise<Survey> => {
    return apiClient.post<Survey>('/admin/surveys', input)
  },

  update: async (id: string, input: UpdateSurveyInput): Promise<Survey> => {
    return apiClient.put<Survey>(`/admin/surveys/${id}`, input)
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/surveys/${id}`)
  },

  publish: async (id: string, input: PublishSurveyInput): Promise<Survey> => {
    return apiClient.post<Survey>(`/admin/surveys/${id}/publish`, input)
  },

  getResults: async (id: string): Promise<SurveyResults> => {
    return apiClient.get<SurveyResults>(`/admin/surveys/${id}/results`)
  },
}
